import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  open: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

const defaultProps = {}

function PdfModal({ open, onClose, url, title }) {
  useEffect(() => {
    if (!open) return
    const onKey = (e) => e.key === 'Escape' && onClose()
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('keydown', onKey)
    }
  }, [open, onClose])

  if (!open) return null

  return (
    <div role="dialog" aria-modal="true" className="pdf-modal-overlay">
      <div className="pdf-modal">
        <div className="pdf-modal__header">
          <span className="pdf-modal__title">{title}</span>
          <button
            type="button"
            className="pdf-modal__close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div className="pdf-modal__body">
          <embed
            src={url}
            type="application/pdf"
            className="pdf-modal__embed"
          />
        </div>
      </div>
    </div>
  )
}

PdfModal.propTypes = propTypes
PdfModal.defaultProps = defaultProps

export default PdfModal
